import { Flex, Text, Skeleton } from "@mantine/core";
import { getNestedFieldValue } from "../../../ideaNiv/helpers/calculateImpactResults";
import { IconAlertOctagon } from "@tabler/icons";
import { DEFAULT_PRIORITY_BACKGROUND_COLOR, DEFAULT_PRIORITY_COLOR } from "../../../../constants/colors";

// PriorityCell Component
export const PriorityCell: React.FC<any> = ({ data, ideaPriorities, col }) => {
  const priority = getNestedFieldValue(data, col.accessor);
  const defaultPriority = ideaPriorities?.find((p: any) => p?.isDefault);
  const selectedPriority = priority
    ? ideaPriorities?.find(
      (p: any) =>
        p?.key?.toLowerCase() === priority?.toLowerCase() ||
            p?.label?.toLowerCase() === priority?.toLowerCase()
    )
    : {
      backgroundColor: DEFAULT_PRIORITY_BACKGROUND_COLOR,
      color: DEFAULT_PRIORITY_COLOR,
      index: 1,
      key: "Unassigned",
      label: "Unassigned",
    };

  const color = selectedPriority?.color || defaultPriority?.color || DEFAULT_PRIORITY_COLOR
  const backgroundColor = selectedPriority?.backgroundColor || defaultPriority?.backgroundColor || DEFAULT_PRIORITY_BACKGROUND_COLOR

  return (
    <Flex >
      
      <Flex  sx={{backgroundColor, borderRadius : 4.7}} p={3}>
        <IconAlertOctagon color={color} size={14} />
        <Text color={color}  ml={4} >
          {selectedPriority?.label ||  defaultPriority?.label ||  "Unassigned"}
        </Text>
      </Flex>
      
    </Flex>
  );
};

// Skeleton component for PriorityCell
export const PriorityCellSkeleton: React.FC<{ col: any }> = ({ col }) => {
  const columnWidth = col.width;
  const minWidth = col.minWidth;
  const maxWidth = col.maxWidth;
  
  // Priority labels are typically 60-120px wide
  const labelWidth = columnWidth ? Math.min(parseInt(columnWidth) * 0.7, 120) : 80;
  
  return (
    <Flex sx={{ width: columnWidth || "100%", minWidth, maxWidth }}>
      <Flex sx={{ backgroundColor: "#f8f9fa", borderRadius: 4.7 }} p={3}>
        <Skeleton height={14} width={14} radius="sm" mr={4} />
        <Skeleton height={14} width={labelWidth} radius="sm" />
      </Flex>
    </Flex>
  );
};